export default __webpack_public_path__ + "static/media/redditDeskFill.177574a4.svg";